import "./cancel-dispatch-error-modal.css";

import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { alertTriangle } from "@tql/ui-components-react/untitled/icons";

import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

export const CancelDispatchErrorModal = ({
	onClose,
	isOpen,
	carrierPhone,
	confirmationNumber,
}: {
	onClose: () => void;
	isOpen: boolean;
	carrierPhone: string | null | undefined;
	confirmationNumber: string | null | undefined;
}) => {
	if (!isOpen) {
		return null;
	}

	return (
		<TraxModal
			className={"cancel-dispatch-error-modal"}
			confirmText={"I understand"}
			confirmVariant={"danger"}
			onClose={onClose}
			onConfirm={onClose}
			showCancelButton={false}
			showConfirmButton={true}
			showConfirmationButtons={true}
			title={"Cancel Dispatch Error"}
			type={"error"}
			width={346}
		>
			<div className={"cancel-dispatch-error-content"}>
				<SvgIcon
					className={"cancel-dispatch-error-icon"}
					icon={alertTriangle}
				/>
				<div className={"cancel-dispatch-error-text"}>
					<p>
						Dispatch could not be cancelled.
						<br />
						Please call the carrier to cancel the dispatch.
					</p>
					<p>
						Carrier Phone #:{" "}
						<span className={"cancel-dispatch-error-phone"}>
							{carrierPhone ?? "N/A"}
						</span>
						<br />
						Carrier Pickup Confirmation #: {confirmationNumber ?? "N/A"}
					</p>
				</div>
			</div>
		</TraxModal>
	);
};
